"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _errors = _interopRequireDefault(require("../errors"));
/**
 * Returns error if router number does not pass checksum calculation
 * @param  {string} val - user entered value
 */
var validRoutingNumber = function validRoutingNumber(val) {
  var value = String(val);
  var checksum = 0;
  if (/^\d{9}$/.test(value)) {
    for (var i = 0; i < value.length; i += 3) {
      checksum += Number(value.charAt(i)) * 3;
      checksum += Number(value.charAt(i + 1)) * 7;
      checksum += Number(value.charAt(i + 2)) * 1;
    }
  }
  return value && (checksum === 0 || checksum % 10 !== 0) ? _errors["default"].routingNumber.validRoutingNumber : undefined;
};
var _default = validRoutingNumber;
exports["default"] = _default;
